<template>
  <div></div>
</template>

<script>
import introJs from "intro.js";
import "intro.js/introjs.css";
export default {
  name: "Onboarding",
  props: ["userType", "action"],
  data() {
    return {
      getUserType: "",

      activePhone: false,
      isTwoFactorAuthenticationEnabled: false,

      lockerSettings: {
        lockerPassword: false,
        isTwoFactorAuthenticationEnabled: false,
        is2faCodeRequired: false,
        isEmailCodeRequired: false,
        isSMSCodeRequired: false,
      },
    };
  },
  watch: {

  lockerSettings() {
      return this.$store.getters['getUser'].lockerSettings;
    },
    handler() {
      this.getAccount();  // Ação executada quando 'lockerSettings' muda
    },
    deep: true, 
    immediate: true
  },
  mounted() {
    this.getUserType = this.$store.getters["getUserType"];
    this.getAccount();
  },
  methods: {
     getAccount() {
      try {
       
          const {
            lockerPassword,
            is2faCodeRequired,
            isEmailCodeRequired,
            isSMSCodeRequired,
            isTwoFactorAuthenticationEnabled,
            activePhone,
          } = this.$store.getters['getUser'].lockerSettings;
          this.lockerSettings.lockerPassword = lockerPassword;
          this.lockerSettings.is2faCodeRequired = is2faCodeRequired;
          this.lockerSettings.isEmailCodeRequired = isEmailCodeRequired;
          this.lockerSettings.isSMSCodeRequired = isSMSCodeRequired;
          this.activePhone = activePhone;
          this.isTwoFactorAuthenticationEnabled =
            isTwoFactorAuthenticationEnabled;
        
      } catch (error) {
        console.log(error);
      }
    },

    async startOnboarding() {
      var self = this;
      const intro = introJs();

      let step_options = [
        {
          element: "#credential",
          intro: self.$ml.get("toAccessTheVaultEnableTheFollowingSteps"),
        },
      ];
      if (!this.activePhone && this.lockerSettings.isSMSCodeRequired) {
        step_options.push({
          element: "#phoneValidation",
          intro: self.$ml.get("registerPhoneOnboarding"),
        });
      }
      if (
        !this.isTwoFactorAuthenticationEnabled &&
        this.lockerSettings.is2faCodeRequired
      ) {
        step_options.push({
          element: "#authentication2fa",
          intro: self.$ml.get("activeTwoFactorAuthentication"),
        });
      }
      if (!this.lockerSettings.lockerPassword) {
        step_options.push({
          element: "#optionCardHeaderSafe",
          intro: self.$ml.get("registerPasswordLocker"),
        });
      }

      intro.setOptions({
        steps: step_options,
        nextLabel: this.$ml.get("btnNext"),
        prevLabel: this.$ml.get("btnPrev"),
        doneLabel: this.$ml.get("conclude"),
      });

      // Garantir que o elemento esteja visível
      intro.onbeforechange((targetElement) => {        
        setTimeout(() => {
          const btnPrev =   document.querySelectorAll('.introjs-prevbutton');
          btnPrev[0].style.display = 'none'
        },2)
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth", block: "end" });
        }
        
      });

      intro.start();
    },

    async startMenu() {
      const intro = introJs();
      intro.setOptions({
        steps: [
          {
            element: "#menuAccount",
            intro: this.$ml.get("onboardingMenuAccount"),
          },
        ],
        // nextLabel: this.$ml.get("btnNext"),
        // prevLabel: this.$ml.get("btnPrev"),
        doneLabel: this.$ml.get("btnNext"),
      });

      intro.onbeforechange((targetElement) => {
        if (targetElement) {
          setTimeout(() => {
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }, 100);
        }
      });

      intro.oncomplete(() => {
        this.$router.push({
          name: "account",
          params: { locker: "locker_onboarding" },
        });
        intro.exit();

        setTimeout(() => {
          if (this.action === "registerPassword") {
            this.onboardingRegisterPhone();
            return;
          }
          this.startOnboarding();
        }, 1200);
      });

      intro.start();
    },

    async onboardingRegisterPhone() {
      const intro = introJs();
      intro.setOptions({
        steps: [
          {
            element: "#phoneValidation",
            intro: this.$ml.get("registerPhoneOnboarding"),
          },
        ],
        // prevLabel: this.$ml.get("btnPrev"),
        doneLabel: this.$ml.get("conclude"),
      });

      intro.onbeforechange((targetElement) => {
        if (targetElement) {
          setTimeout(() => {
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }, 100);
        }
      });

      intro.start();
    },
  },
};
</script>
